import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

// DEBUG: Set to true to bypass authentication and enable role switcher
// const DEBUG_BYPASS_AUTH = true;
const DEBUG_BYPASS_AUTH = false;

const getDebugUser = (role) => ({
  id: 1,
  fullName: role === 'SuperAdmin' ? 'Platform Admin' : role === 'Admin' ? 'Rahul Sharma' : 'Priya Patel',
  email: role === 'SuperAdmin' ? 'superadmin@test.com' : role === 'Admin' ? 'admin@test.com' : 'user@test.com',
  phone: '9999999999',
  roleName: role,
  createdAt: new Date().toISOString(),
  isActive: true
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(DEBUG_BYPASS_AUTH ? getDebugUser('SuperAdmin') : null);
  const [token, setToken] = useState(DEBUG_BYPASS_AUTH ? 'debug-token' : null);
  const [loading, setLoading] = useState(!DEBUG_BYPASS_AUTH);

  useEffect(() => {
    if (DEBUG_BYPASS_AUTH) return;
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    if (savedToken && savedUser) {
      setToken(savedToken);
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  const loginUser = (tokenValue, userData) => {
    localStorage.setItem('token', tokenValue);
    localStorage.setItem('user', JSON.stringify(userData));
    setToken(tokenValue);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setToken(null);
    setUser(null);
  };

  const isAdmin = () => user?.roleName === 'SuperAdmin' || user?.roleName === 'Admin';
  const isSuperAdmin = () => user?.roleName === 'SuperAdmin';

  // DEBUG: Switch role on the fly
  const switchRole = (role) => {
    setUser(getDebugUser(role));
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, loginUser, logout, isAdmin, isSuperAdmin, switchRole, debugMode: DEBUG_BYPASS_AUTH }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
